export const countryOptionss = (countryData) => {
    const uniqueCountries = [...new Set(countryData || [])]; 
    const eventOptions = uniqueCountries.map((item) => ({
        label: item,
        value: item,
    }));

    return eventOptions;
};


export const OperatorOptionsFields = [
    { value: 'telcoAdmin', label: 'Telco' },
    { value: "operatorAdmin", label: 'EV' },
    { value: "genericAdmin", label: 'Generic' },
    { value: "ISPOperatorAdmin", label: 'ISP' },
    { value: "SGCAdmin", label: 'SGC' },
    { value: "evAdmin", label: "EV Admin" },
    { value: "InventoryAdmin", label: "Inventory Admin" }
]

export const OperatorStatusOptions = [
    { value: 'validated', label: 'Active' },
    { value: 'initialized', label: 'Inactive' },
    { value: 'closed', label: 'Cancel' }
]

export const SGCRoleOptions = [
    {value: 'SGCExecutiveUser', label: 'Executive User'},
    {value: 'SGCOperationsUser', label: 'Operations User'},
    {value: 'SGCPowerUser', label: 'Power User'}
]

export const configDisplayNameMapping = {
    ExpiryInSeconds:"Expiry In Seconds",
    ReservationUnitsExpiration:"Reservation Units Expiration",
    UsageEventsPersistanceMode:"Usage Persistance Mode",
    BillingManagement: "Billing Management",
    SessionAudit:"Session Audit",
    SessionAuditBuffer: "Session Audit Buffer",
    Limit:"Limit",
    PaymentManagement: "Payment",
    TaskEnabled: "Tasks",
    BRMTaskEnabled:"BRM Task Integration",
    whatsAppManagement: "WhatsApp",
    notificationManagement: "Notifications",
    identityManagement: "Identity Provider",
    policySpecifications: "Policy Specifications",
    CustomerRetrieval: "Customer Retrieval",
    CustomerSearch: "Customer Search",
    CustomerListing: "Customer Listing",
    selfcare: "Selfcare",
    orderManagement: "Order Management",
    LLM: "LLM",
    taxEnabled: "Tax Management",
    Prefixes: "Prefixes",
    CustomerPrefix: "Account Number Prefix",
    SubscriptionPrefix: "Subscription Prefix",
    OrderPrefix:"Order Prefix",
    SequenceHandling: "Sequence Handling",
    CustomerSequence: "Account Number Sequence",
    SubscriptionSequence: "Subscription Sequence",
    OrderSequence: "Order Sequence",
    Enabled: "EIP",
    DefaultCurrency: "Default Currency",
    CustomerCategory: "Customer Category",
    MLEnabled: "ML Analytics",
    Duration: "Retention Period",
    SubscribedOfferExpiryTime: "Subscribed Offer Expiry Time",
    Days: "Retention Period",
    SessionExpiryBuffer: "Session Expiry",
    SessionExpiryBufferValue: "Session Expiry Buffer Size",
    SessionExpiryType: "Session Expiry Time",
    RetentionInterval: "Stale Session Expiry Time",
    Interval: "Retention Interval",
    MLDatasource: "ML Datasource",
    GlobalFilter: "Global Filter",
    ProviderView: "Provider View",
    ProcedureView: "Procedure View",
    MetricView: "Metric View",
    ProviderScorecard: "Provider Scorecard",
    ColumnSelection: "Column Selection", 
    ColumnSorting: "Column Sorting",
    ColumnReorganizing: "Column Reorganizing",
    ChatMode: "Chat Mode",
    ChatPanel: "Chat Panel",
    datasetVersion: "Dataset Version",
    identityProvider: "Identity Provider"
};

export const notificationDisplayNameMapping = {
    NotificationEnable: "Enable Notifications",
    SetPassword: "Set Password",
    ProfileUpdate : "Profile Update",
    EmailUpdate : "E-mail Update",
    BalanceNotification: "Balance Notification",
    BalanceAVNotification: "Balance AV Notification",
    CreateCustomer: "Create Customer",
    CustomerUpdate: "Customer Update",
    AddOnPurchase: "Add-on Update",
    PurchaseOffer: "Purchase Offer",
    UnsubscribeEmail: "Unsubscribe Email",
    ChangePlan: "Change Plan",
    PaymentOrder: "Payment Order",
    PaymentConfirmation: "Payment Confirmation",
    CancelProductOrder: "Cancel Product Order",
    SubscriptionFailed: "Subscription Failed",
    SubscriptionConfirmed: "Subscription Confirmed",
    CommissionStatement: "Commission Statement",
    CreditLimitNotification: "Credit Limit Notification",
    PasswordReset: "Password Reset",
    PaygNotification: "Payg Notification",
    ThresholdNotification: "Threshold Notification",
    ModelTrainingComplete: "Model Training Complete",
    BatchPredictionComplete: "Batch Prediction Complete"
}